/**
 * /dashboard/performance/one-on-ones — 1:1 list.
 *
 * Migration note: port of
 * frontend/src/app/(dashboard)/dashboard/performance/one-on-ones/page.tsx.
 */

import { createFileRoute } from "@tanstack/react-router";
import { PerformanceModuleShell } from "@/components/shared/performance-module-shell";
import { PerformanceFeatureGate } from "@/components/performance/performance-feature-gate";
import { OneOnOnesTab } from "@/components/performance/one-on-ones-tab";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/performance/one-on-ones/")({
  component: PerformanceOneOnOnesRoute,
});

function PerformanceOneOnOnesRoute() {
  return (
    <PerformanceModuleShell
      title="1:1s"
      description="Schedule and run 1:1s with your manager or reports."
    >
      <PerformanceFeatureGate>
        <OneOnOnesTab />
      </PerformanceFeatureGate>
    </PerformanceModuleShell>
  );
}
